module.exports = __webpack_public_path__ + "media/src/application/media/img_parallax-a64a7f837f3fcf3d2e68b4dbe5fa8686.jpg";